import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import NoMoreDebtTodayWrapper from "@components/layouts/noMoreDebtTodayWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
export default function ContactUsHome(): ReactElement {
    return (
        <NoMoreDebtTodayWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor={"#B6E7FF"} />
            </div>
            <FormSection iconsFillColor={"#1A283D"} />
        </NoMoreDebtTodayWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
